/**
 * Note priorities — My Notes rebuild, Stage 6. Mirrors the backend's
 * notesService.js NOTE_PRIORITIES exactly (kept in sync by hand — no
 * code-sharing mechanism between frontend and backend in this repo).
 */
export const NOTE_PRIORITIES = ['critical', 'important', 'general']
